export default "__VITE_ASSET__793af01e__"